import React from "react";
import kehindeAikomo from "../../assets/staff/MedicalandPsychiatrysocialwork/kehinde_aikomo.jpeg";
import titiTade from "../../assets/staff/Default/female.jpg";
import olapejuOlorundare from "../../assets/staff/MedicalandPsychiatrysocialwork/olapeju_olorundare.jpeg";
import angelaEdozieOgili from "../../assets/staff/MedicalandPsychiatrysocialwork/angela_edozie-ogili.jpeg";
import hildaSasere from "../../assets/staff/MedicalandPsychiatrysocialwork/hilda_sasere.jpeg";
import mariamLiasu from "../../assets/staff/MedicalandPsychiatrysocialwork/mariam_liasu.jpeg";
import ronkeAdedeji from "../../assets/staff/Default/female.jpg";
import rhodaFarinde from "../../assets/staff/MedicalandPsychiatrysocialwork/rhoda_farinde.jpeg";
import olalekanOlasode from "../../assets/staff/MedicalandPsychiatrysocialwork/olalekan_olasode.jpg";
import ijeomaOguamaAmaje from "../../assets/staff/MedicalandPsychiatrysocialwork/ijeoma_oguama-amaje.jpeg";


const MedicalandPsychiatrysocialworkStaff = [
  {
    name: "Aikomo, Kehinde Iyabode",
    designation: "Director/Head, Medical Social Worker",
    qualification: "MSc MSc. Social Work,Master of Social Work (MSW),Post graduate certificate in Medical and Psychiatry Social Work (PGD),BSc. Psychology",
    photo: kehindeAikomo,
  },
  {
    name: "Titi Tade",
    designation: "Director, Medical Social Worker",
    qualification: "MSc. Psychology,Post graduate certificate in Medical and Psychiatry Social Work (PGD),BSc. Psychology",
    photo: titiTade,
    },
  {
    name: "Olorundare, Olapeju Kehinde",
    designation: "Assistant Director, Medical Social Worker",
    qualification: "MSc. Social Work,Post graduate certificate in Medical and Psychiatry Social Work (PGD),BSc. Sociology",
    photo: olapejuOlorundare,
  },
  {
    name: "Edozie-Ogili Angela Chinagorom",
    designation: "Assistant Director, Medical Social Worker",
    qualification: "Master of Social Work (MSW),Post graduate certificate in Medical and Psychiatry Social Work (PGD),BSc. Psychology",
    photo: angelaEdozieOgili,
  },
  {
    name: "Sasere Hilda Ofure",
    designation: "Post graduate certificate in Medical and Psychiatry Social Work (PGD),BSc Social Work,Diploma in Social Development & Administration (SDA)",
    qualification: "Senior Medical Social Worker",
    photo: hildaSasere,
  },
  {
    name: "Oguama-Amaje Ijeoma Gloria",
    designation: "Medical Social Worker II (Lecturer)",
    qualification: "BSc. Sociology & Anthropology",
    photo: ijeomaOguamaAmaje,
  },
  {
    name: "Liasu Mariam Kikelomo",
    designation: "Medical Social Worker II (Lecturer)",
    qualification: "BSc. Sociology",
    photo: mariamLiasu,
  },
{
    name: "Adedeji O. Ronke",
    designation: "Deputy Director HIM (Lecturer)",
    qualification: "MSc. Anatomy (2006),BSc. HIM (2022),BSc. Anatomy (2000),HND  HIM (2005)",
    photo: ronkeAdedeji,
},
{
    name: "Farinde O. Rhoda",
    designation: "Clerical Officer I",
    qualification: "MPH. Public Health (Epidemiology Option),M.Ed Educational Management,PGD Educational Management,PGD Hospital Management,BSc. Mathematics,HND Health Records and Biostatistics",
    photo: rhodaFarinde,
},
{
    name: "Olasode Olalekan",
    designation: "Clerical Officer I",
    qualification: "M.Sc (Industrial/Organizational Psychology,Master of Personnel Psychology (MPP),Master of Business Administration (MBA),PGD Educational Management,BSc. Psychology",
    photo: olalekanOlasode, 
}
];

export default MedicalandPsychiatrysocialworkStaff;